(function() {
    
    window.app = window.app || {};

    var operations = {
        DirectPayment: 0,
        CreditCard: 1,
        PayPal: 2,
        VisaCheckout: 3,
        Masterpass: 4,
        Ourpay: 5,
        Afterpay: 6,
        IPay: 7,

        CurrentCreditCard: 8,
        CurrentPayPal: 9,
        CurrentOurpay: 10,
        CurrentMasterpass: 11,
        CurrentVisacheckout: 12,

        ChangeAddress: 13,
        UseAnotherAddress: 14,
        ChooseAddressTypeSimple: 15,
        ChooseAddressTypePickupPoint: 16,
        ChoosePickupPoint: 17,
        UseThisAddress: 18,
        AddressValidation: 19,
        ChooseSignatureDelivery: 20,

        ChooseDeliveryOption: 21,
        SelectMoreDetails: 22,

        IncreaseItemQty: 23,
        DecreaseItemQty: 24,

        DisplayVoucherField: 25,
        ApplyVoucher: 26,
        HideVoucherField: 27,

        LogIn: 28,

        UserAgreementsTermsAndCondition: 30,
        UserAgreementsReceivePromotional: 31,

        PayOnInitialScreen: 50,
        OurpayOnInitialScreen: 51,

        PayPalCredit: 98,
        CurrentPayPalOurpay: 99,

        ThreeDSecureOpen: 100,
        ThreeDSecurePassed: 101,

        Openpay: 200,

        ZipPayButtonClick: 300,
        ZipPayCreateOrder: 301,
        ZipPayCreateCharge: 302,

        LPayButtonClick: 350,
        LPayCreateOrder: 351,
        LPayCreateCharge:352,

        Humm: 400,

        KlarnaButtonClick: 450,
        KlarnaWidgetLoad: 451,
        KlarnaAuthorize: 452,
        KlarnaFinalize: 453,
        KlarnaCreateOrder: 454,

        StripeCreditCard: 500,
        StripeCurrentCreditCard: 501,
        StripeThreeDSecureOpen: 520,
        StripeThreeDSecurePassed: 521,
        StripeThreeDSecureFail: 522,

        AddressFieldFocus: 600,
        AddressSuggestionShow: 601,
        AddressSuggestionSelect: 602,

        AgeRestrictedOpen: 700,
        AgeRestrictedDisplay: 701,
        AgeRestrictedValid: 704,
        AgeRestrictedNotValid: 705,

        ItemNonLongerAvailable: 800,

        recaptcha_requesttoken: 1003,
        recaptcha_receivetoken: 1004,

        open_contact_us_from_menu: 1035,
        open_new_contact_from_footer: 1037,
        open_new_contact_from_contact_list: 1038,

        login_initialized: 2000,
        login_displayed: 2001,
        login_click: 2002,
        login_fields_not_filled: 2003,

        login_login_method: 2004,
        login_signin_method: 2005,
        login_signin_customer_method: 2006,

        login_success: 2007,

        embeddedLogin_signin_click: 2100,
        embeddedLogin_signin_method: 2101,
        embeddedLogin_signin_customer_method: 2102,
        embeddedLogin_signin_success: 2103,
        embeddedLogin_signup_click: 2104,
        embeddedLogin_signup_method: 2105,
        embeddedLogin_signup_customer_method: 2106,
        embeddedLogin_signup_success: 2107,
        embeddedLogin_forgotPassword_click: 2108,
        embeddedLogin_fields_not_filled: 2109,
        embeddedLogin_pay_button_click: 2110,

        DeleteItemQty: 2225,

        inviteFriend_openPage: 3000,
        inviteFriend_sendInvites_with_personal_invitation: 3001,
        inviteFriend_sendInvites_without_personal_invitation: 3002,

        not_available_deliver_to_location: 4000,

        stripe_loaded: 4100,
        stripe_failed: 4101,

        confirmationInfo: 4200
    };

    var objToString = function(value) {
        if (value === undefined) {
            return 'undefined';
        }
        if (value === null) {
            return 'null';
        }
        if (typeof (value) === 'boolean') {
            return value.toString();
        }
        return '';
    }

    var sendEvent = function(operation, isGuest, isMobile, result, errorDescription) {
        if (result === undefined) {
            result = true;
        }
        errorDescription = errorDescription || '';

        var event = JSON.stringify({
            eventType: 8,
            operation: operation,
            result: result ? 1 : 0,
            errorDescription: errorDescription,
            isGuestCheckout: isGuest,

            frontEndInfo: {
                frontEnd: isMobile ? "Mobile website" : "Desktop website",
                uiVersion:"",
                osVersion:""
            },
            visitorInfo: {
                userCohorts: null,
                userGroup: null,
                company: GlobalSettings.Country.ID,
                region: "",
                visitorId: app.cookie.get('v')
            }
        });
        $.ajax('/api/shop/eventing/v1/events',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: event
            });
    };

    var getCohortsFromCookie = function (ut) {
        var cohortIds = null;
        if (ut) {
            cohortIds = ut.split("&");
            if (cohortIds) {
                for (i = 0; i < cohortIds.length; i++) {
                    cohortIds[i] = cohortIds[i].substring(cohortIds[i].indexOf("=") + 1, cohortIds[i].length);
                }
            }
        }

        return cohortIds;
    }

    var getUserGroupFromCookie = function (usFromCookie) {
        var userGroup = {};
        if (usFromCookie) {
            var obj = usFromCookie.split('&');
            for (var i = 0; i < obj.length; i++) {
                var objItem = obj[i];
                if (objItem) {
                    var b = objItem.split('=');
                    if (b) {
                        userGroup[b[0]] = b[1];
                    }
                }
            }
        }
        return userGroup;
    }

    var sendMyAccountEvent = function (eventType, operation, isMobile) {

        var cohortIds = getCohortsFromCookie(app.cookie.get('ut'));
        var ug = getUserGroupFromCookie(app.cookie.get('us'));

        var event = JSON.stringify({
            eventType: eventType,
            frontEndInfo: {
                frontEnd: isMobile ? "Mobile website" : "Desktop website",
                uiVersion: "",
                osVersion: ""
            },
            featureInfo: {
                type: operation
            },
            visitorInfo: {
                userCohorts: cohortIds,
                userGroup: ug['ug'] ? ug['ug'] : null,
                company: GlobalSettings.Country.ID,
                region: "",
                visitorId: app.cookie.get('v'),
                userId: ""
            }
        });
        $.ajax('/api/shop/eventing/v1/events',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: event
            });
    };

    var sendErrorMessageEvent = function (errorEventType, errorEventName, errorMessage, isMobile) {

        var cohortIds = getCohortsFromCookie(app.cookie.get('ut'));
        var ug = getUserGroupFromCookie(app.cookie.get('us'));

        var event = JSON.stringify({
            eventType: 23,
            errorInfo: {
                type: errorEventType,
                text: errorMessage,
                name: errorEventName
            },
            frontEndInfo: {
                frontEnd: isMobile ? "Mobile website" : "Desktop website",
                uiVersion: "",
                osVersion: ""
            },
            visitorInfo: {
                userCohorts: cohortIds,
                userGroup: ug['ug'] ? ug['ug'] : null,
                company: GlobalSettings.Country.ID,
                region: "",
                visitorId: app.cookie.get('v'),
                userId: ""
            }
        });
        $.ajax('/api/shop/eventing/v1/events',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: event
            });
    };

    window.app.events = {
        initCheckoutEvents: function(isGuest, isMobile) {
            return {
                payOnInitialScreen: function() {
                    /* only for mobile sites */
                    sendEvent(operations.PayOnInitialScreen, isGuest, isMobile);
                },

                ourpayOnInitialScreen: function(result, description) {
                    /* only for mobile sites */
                    sendEvent(operations.OurpayOnInitialScreen, isGuest, isMobile, result, description);
                },

                directPayment: function() {
                    sendEvent(operations.DirectPayment, isGuest, isMobile);
                },

                creditCard: function() {
                    sendEvent(operations.CreditCard, isGuest, isMobile);
                },

                paypal: function() {
                    sendEvent(operations.PayPal, isGuest, isMobile);
                },

                paypalCredit: function() {
                    sendEvent(operations.PayPalCredit, isGuest, isMobile);
                },

                visacheckout: function() {
                    sendEvent(operations.VisaCheckout, isGuest, isMobile);
                },

                masterpass: function() {
                    sendEvent(operations.Masterpass, isGuest, isMobile);
                },

                iPay: function() {
                    sendEvent(operations.IPay, isGuest, isMobile);
                },

                afterpay: function() {
                    sendEvent(operations.Afterpay, isGuest, isMobile);
                },

                openpay: function () {
                    sendEvent(operations.Openpay, isGuest, isMobile);
                },

                ourpay: function() {
                    sendEvent(operations.Ourpay, isGuest, isMobile);
                },

                currentOurpay: function(paymentType) {
                    var operation = operations.CurrentOurpay;
                    if (paymentType && paymentType.toLowerCase() === 'paypal') {
                        operation = operations.CurrentPayPalOurpay;
                    }
                    sendEvent(operation, isGuest, isMobile);
                },

                currentCreditCard: function() {
                    sendEvent(operations.CurrentCreditCard, isGuest, isMobile);
                },

                currentPayPal: function() {
                    sendEvent(operations.CurrentPayPal, isGuest, isMobile);
                },

                currentMasterpass: function() {
                    sendEvent(operations.CurrentMasterpass, isGuest, isMobile);
                },

                currentVisacheckout: function() {
                    sendEvent(operations.CurrentVisacheckout, isGuest, isMobile);
                },
                
                zipPayButtonClick: function () {
                    sendEvent(operations.ZipPayButtonClick, isGuest, isMobile);
                },
                
                zipPayCreateOrder: function () {
                    sendEvent(operations.ZipPayCreateOrder, isGuest, isMobile);
                },
                
                zipPayCreateCharge: function() {
                    sendEvent(operations.ZipPayCreateCharge, isGuest, isMobile);
                },
                
                lPayButtonClick: function () {
                    sendEvent(operations.LPayButtonClick, isGuest, isMobile);
                },
                
                lPayCreateOrder: function () {
                    sendEvent(operations.LPayCreateOrder, isGuest, isMobile);
                },
                
                lPayCreateCharge: function() {
                    sendEvent(operations.LPayCreateCharge, isGuest, isMobile);
                },
                
                humm: function() {
                    sendEvent(operations.Humm, isGuest, isMobile);
                },

                klarnaButtonClick: function () {
                    sendEvent(operations.KlarnaButtonClick, isGuest, isMobile);
                },

                klarnaWidgetLoad: function () {
                    sendEvent(operations.KlarnaWidgetLoad, isGuest, isMobile);
                },

                klarnaAuthorize: function () {
                    sendEvent(operations.KlarnaAuthorize, isGuest, isMobile);
                },

                klarnaFinalize: function () {
                    sendEvent(operations.KlarnaFinalize, isGuest, isMobile);
                },

                klarnaCreateOrder: function () {
                    sendEvent(operations.KlarnaCreateOrder, isGuest, isMobile);
                },


                stripeCreditCard: function() {
                    sendEvent(operations.StripeCreditCard, isGuest, isMobile);
                },
                stripeCurrentCreditCard: function() {
                    sendEvent(operations.StripeCurrentCreditCard, isGuest, isMobile);
                },
                stripeThreeDSecureOpen: function() {
                    sendEvent(operations.StripeThreeDSecureOpen, isGuest, isMobile);
                },
                stripeThreeDSecurePassed: function() {
                    sendEvent(operations.StripeThreeDSecurePassed, isGuest, isMobile);
                },
                stripeThreeDSecureFail: function(error) {
                    sendEvent(operations.StripeThreeDSecureFail, isGuest, isMobile, null, error);
                },


                changeAddress: function() {
                    sendEvent(operations.ChangeAddress, isGuest, isMobile);
                },

                useAnotherAddress: function() {
                    sendEvent(operations.UseAnotherAddress, isGuest, isMobile);
                },

                chooseAddressTypeSimple: function() {
                    sendEvent(operations.ChooseAddressTypeSimple, isGuest, isMobile);
                },

                chooseAddressTypePickupPoint: function() {
                    sendEvent(operations.ChooseAddressTypePickupPoint, isGuest, isMobile);
                },

                choosePickupPoint: function() {
                    sendEvent(operations.ChoosePickupPoint, isGuest, isMobile);
                },

                useThisAddress: function() {
                    sendEvent(operations.UseThisAddress, isGuest, isMobile);
                },

                addressValidation: function(result, errorDescription) {
                    sendEvent(operations.AddressValidation, isGuest, isMobile, result, errorDescription);
                },

                chooseSignatureDelivery: function() {
                    sendEvent(operations.ChooseSignatureDelivery, isGuest, isMobile);
                },

                chooseDeliveryOption: function(optionName) {
                    sendEvent(operations.ChooseDeliveryOption, isGuest, isMobile, true, optionName || '');
                },

                selectMoreDetails: function() {
                    sendEvent(operations.SelectMoreDetails, isGuest, isMobile);
                },

                increaseItemQty: function() {
                    sendEvent(operations.IncreaseItemQty, isGuest, isMobile);
                },

                decreaseItemQty: function() {
                    sendEvent(operations.DecreaseItemQty, isGuest, isMobile);
                },

                deleteOrderItem: function() {
                    sendEvent(operations.DeleteItemQty, isGuest, isMobile);
                },

                displayVoucherField: function() {
                    sendEvent(operations.DisplayVoucherField, isGuest, isMobile);
                },

                applyVoucher: function() {
                    sendEvent(operations.ApplyVoucher, isGuest, isMobile);
                },

                hideVoucherField: function() {
                    sendEvent(operations.HideVoucherField, isGuest, isMobile);
                },

                logIn: function() {
                    sendEvent(operations.LogIn, isGuest, isMobile);
                },

                userAgreementsTermsAndCondition: function(value) {
                    sendEvent(operations.UserAgreementsTermsAndCondition, isGuest, isMobile, true, objToString(value));
                },

                userAgreementsReceivePromotional: function(value) {
                    sendEvent(operations.UserAgreementsReceivePromotional, isGuest, isMobile, true, objToString(value));
                },

                threeDSecureOpen: function() {
                    sendEvent(operations.ThreeDSecureOpen, isGuest, isMobile);
                },

                threeDSecurePassed: function() {
                    sendEvent(operations.ThreeDSecurePassed, isGuest, isMobile);
                },
                
                addressFieldFocus: function() {
                    sendEvent(operations.AddressFieldFocus, isGuest, isMobile);
                },

                addressSuggestionShow: function() {
                    sendEvent(operations.AddressSuggestionShow, isGuest, isMobile);
                },

                addressSuggestionSelect: function() {
                    sendEvent(operations.AddressSuggestionSelect, isGuest, isMobile);
                },

                ageRestrictedDisplay: function () {
                    sendEvent(operations.AgeRestrictedDisplay, isGuest, isMobile);
                },

                ageRestrictedOpen: function () {
                    sendEvent(operations.AgeRestrictedOpen, isGuest, isMobile);
                },

                ageRestrictedNotValid: function () {
                    sendEvent(operations.AgeRestrictedNotValid, isGuest, isMobile);
                },

                ageRestrictedValid: function () {
                    sendEvent(operations.AgeRestrictedValid, isGuest, isMobile);
                },

                itemNonLongerAvailable: function () {
                    sendEvent(operations.ItemNonLongerAvailable, isGuest, isMobile);
                },

                notAvailableDeliverToLocation: function () {
                    sendEvent(operations.not_available_deliver_to_location, isGuest, isMobile);
                },

                stripeLoaded: function () {
                    sendEvent(operations.stripe_loaded, isGuest, isMobile);
                },

                stripeFailed: function () {
                    sendEvent(operations.stripe_failed, isGuest, isMobile);
                },

                confirmationInfo: function (info) {
                    sendEvent(operations.confirmationInfo, isGuest, isMobile, true, info.replace(/.*(.{20}$)/g, '***$1'));
                }
            };
        },
        login: {
            initialized: function () {
                sendEvent(operations.login_initialized, false, false);
            },
            displayed: function () {
                sendEvent(operations.login_displayed, false, false);
            },
            click: function () {
                sendEvent(operations.login_click, false, false);
            },
            fields_not_filled: function () {
                sendEvent(operations.login_fields_not_filled, false, false);
            },

            login_method: function () {
                sendEvent(operations.login_login_method, false, false);
            },
            signin_method: function () {
                sendEvent(operations.login_signin_method, false, false);
            },
            signin_customer_method: function () {
                sendEvent(operations.login_signin_customer_method, false, false);
            },

            success: function () {
                sendEvent(operations.login_success, false, false);
            }
        },
        embeddedLogin: {
            signinClick: function () {
                sendEvent(operations.embeddedLogin_signin_click, false, false);
            },
            signin_method: function () {
                sendEvent(operations.embeddedLogin_signin_method, false, false);
            },
            signin_customer_method: function () {
                sendEvent(operations.embeddedLogin_signin_customer_method, false, false);
            },
            signin_success: function () {
                sendEvent(operations.embeddedLogin_signin_success, false, false);
            },

            signupClick: function () {
                sendEvent(operations.embeddedLogin_signup_click, false, false);
            },
            signup_method: function () {
                sendEvent(operations.embeddedLogin_signup_method, false, false);
            },
            signup_customer_method: function () {
                sendEvent(operations.embeddedLogin_signup_customer_method, false, false);
            },
            signup_success: function () {
                sendEvent(operations.embeddedLogin_signup_success, false, false);
            },

            forgotPasswordClick: function () {
                sendEvent(operations.embeddedLogin_forgotPassword_click, false, false);
            },

            fields_not_filled: function () {
                sendEvent(operations.embeddedLogin_fields_not_filled, false, false);
            },

            pay_button_click: function () {
                sendEvent(operations.embeddedLogin_pay_button_click, false, false);
            }
        },
        recaptcha: {
            requesttoken:  function() {
                sendEvent(operations.recaptcha_requesttoken, false, false);
            },
            receivetoken:  function() {
                sendEvent(operations.recaptcha_receivetoken, false, false);
            }
        },
        initMyAccountEvents: function (isMobile) {
            return {
                open_contact_us_from_menu: function () {
                    sendMyAccountEvent(18, operations.open_contact_us_from_menu, isMobile);
                },
                open_new_contact_from_footer: function () {
                    sendMyAccountEvent(18, operations.open_new_contact_from_footer, isMobile);
                },
                open_new_contact_from_contact_list: function () {
                    sendMyAccountEvent(18, operations.open_new_contact_from_contact_list, isMobile);
                }
            }
        },
        inviteFriend: {
            open: function () {
                sendEvent(operations.inviteFriend_openPage, false, false);
            },
            sendInvites: function (result, errorDescription, hasPersonalInvitation) {
                if (hasPersonalInvitation) {
                    sendEvent(operations.inviteFriend_sendInvites_with_personal_invitation, false, false, result, errorDescription);
                } else {
                    sendEvent(operations.inviteFriend_sendInvites_without_personal_invitation, false, false, result, errorDescription);
                }
            }
        },
        sendErrorMessageEvents: {
            sendErrorMessageEvent: function (errorEventType, errorEventName, errorMessage, isMobile) {
                sendErrorMessageEvent(errorEventType, errorEventName, errorMessage, isMobile);
            }
        }
    };
})();